import {gsap} from 'gsap';
export let lib = {
    bomb: {
        createTimeline(container) {
            let wick = container.querySelectorAll('.bomb__wick'),
                lights = container.querySelectorAll('.bomb__light');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(lights, {scale: 0, transformOrigin: '50% 50%'})
                .set(wick, {x: 0, y: 0})
                .fromTo(
                    wick,
                    {x: 0, y: 0},
                    {
                        duration: 1,
                        keyframes: [
                            {x: 0, y: 0},
                            {x: -80, y: 50},
                            {x: -135, y: 145}
                        ]
                    },
                    0
                )
                .fromTo(lights, {scale: 0, transformOrigin: '50% 50%'}, {duration: 3, scale: 2, transformOrigin: '50% 50%', stagger: {each: 0.3}}, 1);
            return timeline;
        },
        fromTo: ['top-top', 'bottom-top']
    },
    train: {
        createTimeline(container) {
            let train = container.querySelectorAll('.train__train');
            let timeline = gsap.timeline({paused: true});
            timeline.set(train, {scale: 1}).fromTo(train, {scale: 1}, {scale: 7, transformOrigin: '50% 30%', ease: 'power1.in'});
            return timeline;
        },
        fromTo: ['top-top', 'bottom-top']
    },
    hourglass: {
        createTimeline(container) {
            let wrapper = container.querySelectorAll('.hourglass__wrapper'),
                sandTop = container.querySelectorAll('.hourglass__sand-top'),
                sandBottom = container.querySelectorAll('.hourglass__sand-bottom');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(wrapper, {rotate: 0})
                .set(sandTop, {rotate: 0, y: 0})
                .set(sandBottom, {y: -200})
                .fromTo(wrapper, {rotate: 0}, {duration: 1, rotate: 180, transformOrigin: '50% 50%', ease: 'none'}, 0)
                .fromTo(
                    sandTop,
                    {rotate: 0, y: 0},
                    {
                        keyframes: [
                            {duration: 1, y: -120, transformOrigin: '50% 50%', ease: 'none'},
                            {duration: 1, y: -600}
                        ]
                    },
                    0
                )
                .fromTo(sandBottom, {y: -200}, {duration: 1, y: 0, ease: 'none'}, 1.1);
            return timeline;
        },
        fromTo: ['top-top', 'bottom-bottom']
    },
    theater: {
        createTimeline(container) {
            let cols = container.querySelectorAll('.theater__col');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(cols, {y: 0})
                .fromTo([cols[0], cols[cols.length - 1]], {y: 0}, {y: '-30%'}, 0)
                .fromTo([cols[1], cols[cols.length - 2]], {y: 0}, {y: '-50%'}, 0)
                .fromTo([cols[2], cols[cols.length - 3]], {y: 0}, {y: '-70%'}, 0)
                .fromTo([cols[3], cols[cols.length - 4]], {y: 0}, {y: '-90%'}, 0);
            return timeline;
        },
        fromTo: ['top-top', 'bottom-top']
    },
    cards: {
        createTimeline(container) {
            let cards = container.querySelectorAll('.card');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(cards, {y: 0, x: 0, rotate: 0, scale: 1})
                .fromTo(cards[0], {x: 0, rotate: 0}, {duration: 1, x: '35%', rotate: 45, transformOrigin: '50% 100%', ease: 'power1.in'}, 0)
                .fromTo(cards[2], {x: 0, rotate: 0}, {duration: 1, x: '-35%', rotate: -45, transformOrigin: '50% 100%', ease: 'power1.in'}, 0)

                .fromTo(
                    cards[0],
                    {x: '35%', rotate: 45, scale: 1},
                    {duration: 3, x: '50%', y: '10%', scale: 1.5, rotate: 70, transformOrigin: '50% 100%', ease: 'power1.out'},
                    1
                )
                .fromTo(
                    cards[1],
                    {x: 0, rotate: 0},
                    {duration: 3, x: '0', y: '-120%', scale: 1.5, rotate: 50, transformOrigin: '50% 100%', ease: 'power1.out'},
                    1
                )
                .fromTo(
                    cards[2],
                    {x: '-35%', rotate: -45},
                    {duration: 3, x: '-80%', y: '-15%', scale: 1.5, rotate: -120, transformOrigin: '50% 100%', ease: 'power1.out'},
                    1
                );
            return timeline;
        },
        fromTo: ['top-top', 'bottom-top']
    },
    forest: {
        createTimeline(container) {
            let forestSpruces = container.querySelector('.forest__spruces'),
                forestSpruceArr = container.querySelectorAll('.forest__spruce');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(forestSpruces, {scale: 1})
                .set(forestSpruceArr, {x: 0})
                .fromTo(forestSpruces, {scale: 1}, {scale: 3, transformOrigin: '50% 70%'}, 0)
                .fromTo(forestSpruceArr[0], {x: 0}, {x: '-25%'}, 0)
                .fromTo(forestSpruceArr[1], {x: 0}, {x: '-15%'}, 0)
                .fromTo(forestSpruceArr[2], {x: 0}, {x: '-5%'}, 0)
                .fromTo(forestSpruceArr[3], {x: 0}, {x: '5%'}, 0)
                .fromTo(forestSpruceArr[4], {x: 0}, {x: '15%'}, 0)
                .fromTo(forestSpruceArr[5], {x: 0}, {x: '25%'}, 0);
            return timeline;
        },
        fromTo: ['top-top', 'bottom-top']
    },
    default: {
        createTimeline(container) {
            let timeline = gsap.timeline({paused: true});
            timeline.fromTo(container, {opacity: 0}, {opacity: 1, ease: 'none'}, 0);
            return timeline;
        },
        fromTo: ['bottom-bottom', 'top-top']
    }
};
